module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_3_2_5.7db43c37.png";